import { INeoAction } from './../Actions.interface';
import { STATIC_ACTIONS } from '../../Constants/Actions.constants';
import IWarningKey from '../../Models/Warning.model';

const INITIAL_STATE: Record<IWarningKey, boolean> = {
  uscLocationChangeWarning: false,
  cooperationCategoryChangeWarning: false,
};

type State = Record<IWarningKey, boolean>;
export default (state: State = INITIAL_STATE, action: INeoAction): State => {
  const { name, payload } = action;

  if (name === STATIC_ACTIONS.DISMISS_WARNING) {
    return {
      ...state,
      [payload.warning as IWarningKey]: true,
    };
  }

  return state;
};
